export { default } from './GridSeoConfigs.vue'
